import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import "./Email.css"

const Emailjs = () => {
    const form = useRef();
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus(null);

        emailjs
            .sendForm(
                "service_j1bnyc9",
                "template_bx0rlfe",
                form.current,
                "FUg7VxhLQAs-Lz_mb"
            )
            .then(
                (result) => {
                    console.log(result.text);
                    setStatus({ type: "success", message: "Message sent successfully" });
                    setLoading(false);
                    form.current.reset();
                },
                (error) => {
                    console.log(error.text);
                    setStatus({ type: "error", message: "Failed to send message, try again later." });
                    setLoading(false);
                }
            );
    };

    return (
        <div className='Contact-container'>
            <span className='contact-title1'>Send a Message</span>
            <h2 className='contact-title'>Tell us what you're looking for.</h2>
            <form ref={form} onSubmit={sendEmail} className='contact-form'>
                <label>FULL NAME</label>
                <input placeholder='Your name' name='user_name' required />

                <label>PHONE</label>
                <input placeholder='+91 xxxxx xxxxx' name='user_phone' required />

                <label>I'm Interested In</label>
                <select name='user_profile' required defaultValue="">
                    <option value="" disabled>Select your profile</option>
                    <option value="Beginner">Beginner Investor</option>
                    <option value="Experienced">Experienced Investor</option>
                    <option value="Professional">Professional / Trader</option>
                    <option value="Business">Business Owner</option>
                </select>





                <label>Message</label>
                <textarea name='message' placeholder='Tell us bit about your goals'></textarea>

                <button type='submit' disabled={loading}>
                    {loading ? "Sending..." : "Send"}
                </button>
            </form>

            {status && (
                <p className={`status-message ${status.type}`}>
                    {status.message}
                </p>
            )}
        </div>
    )
}

export default Emailjs